import React from 'react';

export default props => {
    return (
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                style={{transform: "translate(-73px, -24px)"}}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M118 48.0001C118 59.0458 109.046 68 98 68C86.9543 68 78 59.0458 78 48.0001C78 36.9542 86.9543 28 98 28C109.046 28 118 36.9542 118 48.0001Z"
                fill="white"
                />
            <path
                style={{transform: "translate(-73px, -24px)"}}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M98.2277 59.4999C92.7372 59.5182 87.025 54.8105 87.0001 47.2512C86.9834 42.2521 89.6681 37.4401 93.0997 34.5853C96.4468 31.8008 101.032 30.0138 105.191 30.0001C105.726 29.9982 106.286 30.0431 106.629 30.1595C102.993 30.9172 100.099 34.317 100.112 38.174C100.112 38.3015 100.123 38.4377 100.136 38.5012C106.221 39.99 108.983 43.6785 109 48.7821C109.017 53.8854 105.006 59.4773 98.2277 59.4999Z"
                fill="#E60000"
            />
        </svg>
    )
}